import * as Yup from 'yup';

export const TemplateFormSchema = Yup.object({
  templateTitle: Yup.string()
    .min(3, 'El nombre del template debe tener al menos 3 caracteres')
    .max(30, 'El nombre del template no puede tener más de 30 caracteres')
    .required('El título del template es requerido')
    .matches(
      /^\s*\S[\s\S]*$/,
      'Este campo no puede tener solo espacios en blanco',
    ),
});
